module.exports = __webpack_public_path__ + "assets/img/组 169@2x.9587ee80.png";